import { createProgressActions, createActionCreators } from '../utils';
import { createAction } from 'redux-actions';

const search = createActionCreators(createProgressActions('SEARCH'));

const actions = {
  search: search.names,
}
export default actions;

export { search };



// WEBPACK FOOTER //
// ./src/app/models/Search/actions.ts